export default __webpack_public_path__ + "static/media/march-2021.ce372543.csv";